import React from "react";
import ContactInfo from "./contact/ContactInfo";
// import Card from "./card/Card";
import "./NotificationMainPage.scss";
import NotificationCard from "./card/Card";
const NotificationMainPage = ({ data = [] }) => {
  return (
    <div className="notification-mainpage-width">
      <ContactInfo />
      <NotificationCard data={data} />
    </div>
  );
};

export default NotificationMainPage;
